import React, { useCallback } from 'react';

import { JourneyAlias } from 'src/common/interfaces/journey/alias.interface';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { Nullable } from 'src/types/nullable.type';
import { SharePanelLinkList } from './tabs/additional-links/list';

import { useSharePanelStore } from 'src/common/store/share.store';
import ShareSlideOverInfoBanner from './info-banner';

export interface ShareContentCommonProps {
  onAliasUpdate: (alias: JourneyAlias, thumbnailUrl: Nullable<string>) => void;
}

interface ShareContentProps extends ShareContentCommonProps {
  onUpdateJourney: (params: any) => void;
}

const ShareSlideoverContent = ({ onUpdateJourney, onAliasUpdate }: ShareContentProps) => {
  const { setSuccessNotification } = useNotificationMessage();

  const aliases = useSharePanelStore((state) => state.sharedJourney?.aliases);

  const onAliasDelete = useCallback(
    (alias: JourneyAlias) => {
      if (aliases) {
        onUpdateJourney({
          aliases: aliases.filter((a: JourneyAlias) => a.id !== alias.id) || aliases,
        });
        setSuccessNotification('Deleted the link successfully');
      }
    },
    [aliases, onUpdateJourney, setSuccessNotification]
  );

  if (!aliases) return null;

  return (
    <div className='flex flex-col space-y-6 justify-between h-full'>
      <div className='flex flex-col gap-6'>
        <SharePanelLinkList aliases={aliases} onAliasUpdate={onAliasUpdate} onAliasDelete={onAliasDelete} />
      </div>

      <ShareSlideOverInfoBanner linkCount={aliases.length} />
    </div>
  );
};

export default ShareSlideoverContent;
